import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import {getGemsTokenContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const ApproveGems1 = () => {

  const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.gems;
  const tokenAddress1 = Environment.instituson;
  const contract = getGemsTokenContract(tokenAddress, web3);


  const approveGems1 = useCallback(
    async (amount) => {
      try {
        let nd = web3.utils.toWei(amount.toString(), "ether");
        // let gasPrice = await web3.eth.getGasPrice();
        // gasPrice = parseInt(gasPrice) + 5000000000;
        const gas = await contract.methods
          .approve(tokenAddress1, nd)
          .estimateGas({ from: account });
        // let gasPrice = await web3.eth.getGasPrice();
        const details = await contract.methods
          .approve(tokenAddress1, nd)
          .send({
            from: account,
            gas: gas,
            // gasPrice,
          });
        return details;
        // console.log('sdsdss' ,  buy)
        // return details;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return {approveGems1: approveGems1};
};
export default ApproveGems1;